import { getToggleLabel } from "../label-utils/label-utils";

export function SegmentedToggle({
  item,
  value,
  error,
  helperText,
  disabled,
  onValueChange,
  className,
  labelClassName
}) {
  if (disabled) {
    return (
      <span className={`text-sm text-gray-900 ${labelClassName || ""}`}>
        {getToggleLabel(item.options, value)}
      </span>
    );
  }

  return (
    <div
      className={`
        inline-flex items-stretch overflow-hidden rounded-[10px] border
        ${error ? "border-red-500" : "border-gray-300"}
        ${className || ""}
      `}
    >
      {item.options?.map((option, index) => {
        const isSelected = value === option.value;
        const isOptionDisabled = disabled || option.disabled;
        return (
          <button
            key={String(option.value)}
            type='button'
            disabled={isOptionDisabled}
            onClick={() => !isOptionDisabled && onValueChange?.(option.value)}
            className={`
              flex-1 px-8 py-3 text-sm whitespace-nowrap
              ${index > 0 ? "border-l border-gray-300" : ""}
              ${
                isSelected
                  ? "bg-[#343C76] text-white font-medium"
                  : "bg-white text-gray-900 font-normal"
              }
              ${
                isOptionDisabled
                  ? "cursor-not-allowed opacity-70"
                  : "cursor-pointer"
              }
              ${labelClassName || ""}
            `}
          >
            {option.label}
          </button>
        );
      })}
      {error && helperText && <span className='sr-only'>{helperText}</span>}
    </div>
  );
}
